import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { IncomingInvoiceSimilarListProps } from "models/propTypes/incomingInvoicePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { Amount } from "models/utilTypes/currencyType";
//#endregion
//#region components
import { ViewPanel, useMountedState, TableAsync, SubTitleWithIcon } from "components/common";
import IncomingInvoiceStatusTags from "./statusTags";
import { useNavigate, useLocation } from "react-router-dom";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const IncomingInvoiceSimilarList: React.FC<IncomingInvoiceSimilarListProps> = (props) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const { getMounted } = useMountedState();
  const location = useLocation();
  const navigate = useNavigate();

  const [invoices, setInvoices] = React.useState<WintSuperkollAPIModel.IncomingInvoiceSimilarItem[]>();

  React.useEffect(() => {
    incomingInvoiceService.getSimilarInvoices(props.id).then((result) => {
      getMounted() && setInvoices(result);
    });
  }, [props.id]);

  const onRowClick = (row: WintSuperkollAPIModel.IncomingInvoiceSimilarItem) => {
    navigate(UrlHelper.formatPath(`/IncomingInvoice/${row.id}`), {
      state: { background: location },
    });
  };

  return (
    <>
      {invoices && invoices.length > 0 && (
        <ViewPanel
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Similar)}
          icon={IconDefinitionConstants.WDocument}
        >
          <>
            <SubTitleWithIcon
              subTitle={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Common.SimilarSuggestionText,
                undefined,
                { itemCount: `${invoices.length}` }
              )}
              icon={IconDefinitionConstants.WBolt}
            ></SubTitleWithIcon>
            <TableAsync<WintSuperkollAPIModel.IncomingInvoiceSimilarItem>
              properties={{
                date: {
                  description: TranslationKeys.Common.Date,
                  formatter: (values: WintSuperkollAPIModel.IncomingInvoiceSimilarItem) =>
                    values.date && new Date(values.date),
                  noWrap: true,
                },
                accountName: {
                  description: TranslationKeys.Common.PostedAs,
                },
                sender: {
                  description: TranslationKeys.Common.Sender,
                },
                amount: {
                  description: TranslationKeys.Common.Amount,
                  formatter: (values: WintSuperkollAPIModel.IncomingInvoiceSimilarItem) =>
                    new Amount(values.currency, values.amount),
                  alignment: "right",
                  className: cssExports.textBlack,
                },
                state: {
                  description: TranslationKeys.Common.Status,
                  formatter: (values: WintSuperkollAPIModel.IncomingInvoiceSimilarItem) => (
                    <IncomingInvoiceStatusTags status={values.state} />
                  ),
                },
              }}
              filter={invoices}
              rowClickHandler={onRowClick}
              pagination={false}
            />
          </>
        </ViewPanel>
      )}
    </>
  );
};

export default IncomingInvoiceSimilarList;
